import { Box, Tooltip, Typography } from '@mui/material';
import { ReactNode, useCallback } from 'react';
import { MdContentCopy, MdRefresh } from 'react-icons/md';
import Button from './Button';
import IconButton from './IconButton';

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong, if the issue persists please contact us.';

const ErrorState = ({
  message = DEFAULT_ERROR_MESSAGE,
  logo,
  traceId,
  onRetry = () => window.location.reload(),
}: {
  message?: string;
  logo?: ReactNode;
  traceId?: string | null;
  onRetry?: () => void;
}) => {
  const handleCopyTraceId = useCallback(() => {
    if (!traceId) return;
    void navigator.clipboard.writeText(traceId);
  }, [traceId]);

  return (
    <Box
      sx={(theme) => ({
        width: '100%',
        textAlign: 'center',
        marginTop: theme.spacing(8),
      })}
    >
      {logo}

      <Box sx={{ my: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Typography variant="h6" color="error">
          {message}
        </Typography>
        {traceId && (
          <Tooltip title="Copy trace ID">
            <IconButton size="small" color="error" onClick={handleCopyTraceId} aria-label="Copy trace ID">
              <MdContentCopy />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      <Button onClick={onRetry} startIcon={<MdRefresh size={20} />} variant="contained">
        Refresh
      </Button>
    </Box>
  );
};

export default ErrorState;
